export default __webpack_public_path__ + "static/media/indoor-air-quality.3ee42922.svg";